import styled from 'styled-components';

export default styled.i`
  font-size: 1.25em;
  opacity: 0.25;
  transition: opacity 0.1s ease;
`;
